import { Button, Flex, H2, P, Space } from '@dnb/eufemia';
import { Form, Value } from '@dnb/eufemia/extensions/forms';
import { CreateAppApiEntitlementsResponseDto } from '@portals/shared/portal/AppApiEntitlementDto';

import Divider from '@/components/Divider';

import clapIllustrationUrl from '@/illustrations/clap.svg?url';

export default function Success({
  response,
  onModalClose,
}: {
  response: CreateAppApiEntitlementsResponseDto;
  onModalClose: () => void;
}) {
  const isAnyChange =
    response.liveScopesRemoved.length > 0 ||
    response.testScopesRemoved.length > 0 ||
    response.testScopesAdded.length > 0 ||
    response.request;
  return (
    <Form.Card bottom="large">
      <Flex.Container align="center" direction="vertical" justify="center">
        <H2 bottom={0}>Yay!</H2>

        <Space bottom="medium">
          <img alt="Hands clapping" src={clapIllustrationUrl} />
        </Space>
        {!isAnyChange && (
          <P bottom="small" weight="bold">
            No changes were made to your app&apos;s entitlements. Your access settings remain the same.
          </P>
        )}
        {response.request && (
          <P bottom="small" weight="bold">
            Your request has been successfully submitted.
          </P>
        )}

        <Divider />

        {(response.liveScopesRemoved.length > 0 ||
          response.testScopesRemoved.length > 0 ||
          response.testScopesAdded.length > 0) && (
          <Value.SummaryList>
            <P bottom="small">
              {response.request
                ? 'In addition to your request, the following changes have been made: '
                : 'The following changes have been made:'}
            </P>
            {response.liveScopesRemoved.length > 0 && (
              <Value.String
                label={response.liveScopesRemoved.length > 1 ? 'Live Scopes Removed' : 'Live Scope Removed'}
                value={response.liveScopesRemoved.join(', ')}
              />
            )}
            {response.testScopesRemoved.length > 0 && (
              <Value.String
                label={response.testScopesRemoved.length > 1 ? 'Test Scopes Removed' : 'Test Scope Removed'}
                value={response.testScopesRemoved.join(', ')}
              />
            )}
            {response.testScopesAdded.length > 0 && (
              <Value.String
                label={response.testScopesAdded.length > 1 ? 'Test Scopes Added' : 'Test Scope Added'}
                value={response.testScopesAdded.join(', ')}
              />
            )}
          </Value.SummaryList>
        )}
        <Button
          onClick={() => {
            onModalClose();
          }}
          size="large"
          top="large"
        >
          Go to application
        </Button>
      </Flex.Container>
    </Form.Card>
  );
}
